import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Ensure DOM is ready before rendering
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
